import React,{Component} from 'react';
import './App.css';
import {
  Switch,
  Route
} from "react-router-dom";
import Aboutme from "./pages/Aboutme";
import Services from "./pages/Services";
import Home from "./pages/Home";
import PrivacyAndTerms from "./pages/PrivacyAndTerms";
import PrivacyPolitic from "./pages/PrivacyPolitic";

// import Experience from "./pages/Experience";
import Tools from "./pages/Tools";
import Advantages from "./pages/Advantages";
class App extends Component {

  constructor(props) {
    super(props);
    this.state = {

    };
  }

  componentDidMount() {
    var elemm = document.getElementById('body-presentation-gaviria-it');
    if(window.screen.width < 700) {
      elemm.style.height = 'auto';
    }
  }

  render() {
    return (
      <Switch>
        
        <Route path="/terminos-y-condiciones" exact component={PrivacyAndTerms} />
        <Route path="/politica-de-privacidad" exact component={PrivacyPolitic} />
        <Route path="/about/" component={Aboutme}/>
        <Route path="/contact/" component={Aboutme}/>
        <Route path="/services/" component={Services}/>
        {/* <Route path="/experience/" component={Experience}/> */}
        <Route path="/tools/" component={Tools}/>
        <Route path="/advantages/" component={Advantages}/>
        <Route path="/" exact component={Home} >
        </Route>
      </Switch>
    );
  }


}

export default App;
